import {
  DEFAULT_CONSENT_OPTIONS,
  type ConsentParams,
  type CookieCategories,
} from '../../constants';

/**
 * Convert CookieConsent category list to the full GA consent object.
 * - analytics -> analytics_storage
 * - necessary -> is implied and does not toggle GA keys
 * - functional -> functionality_storage, personalization_storage
 * // COOKIES: Leave it here in case we add these cookies in the future
 * - marketing -> ad_storage, ad_user_data, ad_personalization
 */
const mapCookieCategoriesToGaConsent = (
  categories: Array<CookieCategories>,
): ConsentParams => {
  const base: ConsentParams = { ...DEFAULT_CONSENT_OPTIONS };

  if (categories.includes('analytics')) base.analytics_storage = 'granted';

  return base;
};

export default mapCookieCategoriesToGaConsent;
